import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { MessageService } from 'primeng/api';
// import { TranslaterService } from './services/translater-service';
// import { provideTransloco, getBrowserCultureLang } from '@jsverse/transloco';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideAnimationsAsync(), provideHttpClient(withFetch()), MessageService, provideHttpClient()]
};


// , provideTransloco({
//   config: {
//     availableLangs: ['en-US', 'it-IT'],
//     defaultLang: getBrowserCultureLang(),
//     fallbackLang: 'en-US',
//     reRenderOnLangChange: true,
//     prodMode: !isDevMode(),
//   },
//   loader: TranslaterService
// })